export default __webpack_public_path__ + "static/4-7323f4860eac9b997fe9104f84c8d1dc.jpg";